var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.259 0.998566C16.5412 1.17833 16.8099 1.37536 17.0634 1.58832C19.462 3.78169 21.8391 5.98831 24.2449 8.2148C24.403 8.33448 24.5236 8.49092 24.5943 8.66799C24.665 8.84505 24.6832 9.03631 24.647 9.22203C24.6077 9.39843 24.5175 9.56176 24.3859 9.69479C24.2543 9.82783 24.0863 9.92562 23.8995 9.97787C23.7127 10.0301 23.5141 10.0349 23.3246 9.99166C23.1351 9.94843 22.9618 9.85882 22.8229 9.73227C22.3346 9.28829 21.8462 8.83769 21.3866 8.40697L17.3722 4.68952L17.0706 4.42446V21.7063C17.0777 21.8211 17.0777 21.9361 17.0706 22.0509C17.0706 22.3145 16.9571 22.5673 16.755 22.7537C16.553 22.9401 16.279 23.0449 15.9933 23.0449C15.7076 23.0449 15.4336 22.9401 15.2316 22.7537C15.0296 22.5673 14.9161 22.3145 14.9161 22.0509C14.909 21.9361 14.909 21.8211 14.9161 21.7063V4.42446L14.6145 4.68952L9.23556 9.61299C9.09976 9.76127 8.92042 9.87017 8.71911 9.9266C8.51781 9.98303 8.30312 9.98458 8.10088 9.93106C7.914 9.88659 7.74434 9.79476 7.61108 9.66594C7.47782 9.53712 7.38628 9.37647 7.34683 9.20215C7.302 9.01781 7.31315 8.82564 7.37903 8.64677C7.44492 8.4679 7.56299 8.30926 7.72027 8.1883L12.338 3.92747C13.1997 3.13229 14.0543 2.33049 14.9305 1.54194C15.1808 1.34816 15.4421 1.16678 15.7133 0.998566L16.259 0.998566Z",
    fill: "url(#paint0_linear_1633_7154)",
    stroke: "url(#paint1_linear_1633_7154)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1606 27.3123C31.1103 27.4515 31.0672 27.5906 31.0098 27.7232C30.8568 28.0895 30.5896 28.4058 30.2419 28.6323C29.8943 28.8587 29.4818 28.9851 29.0564 28.9954H3.1241C2.58822 29.03 2.05769 28.8786 1.63654 28.5709C1.21539 28.2632 0.934003 27.8214 0.847569 27.3322C0.836618 27.2286 0.836618 27.1243 0.847569 27.0207C0.847569 25.6954 0.847569 24.3702 0.847569 23.0449C0.829999 22.9047 0.844756 22.7627 0.890872 22.6281C0.936988 22.4936 1.01342 22.3696 1.11515 22.2642C1.21688 22.1589 1.34161 22.0746 1.48114 22.0169C1.62068 21.9591 1.77187 21.9293 1.92479 21.9293C2.07771 21.9293 2.2289 21.9591 2.36844 22.0169C2.50798 22.0746 2.6327 22.1589 2.73443 22.2642C2.83616 22.3696 2.91259 22.4936 2.95871 22.6281C3.00483 22.7627 3.01958 22.9047 3.00201 23.0449C3.00201 24.2376 3.00201 25.437 3.00201 26.6364V26.9942H28.9918V23.1575C28.9568 22.9008 29.0273 22.6414 29.1896 22.4303C29.3518 22.2193 29.5938 22.0721 29.8679 22.0177C30.1267 21.9725 30.3945 22.0145 30.6226 22.1361C30.8506 22.2577 31.0237 22.4509 31.1103 22.6804C31.1103 22.6804 31.1462 22.6804 31.1606 22.7202V27.3123Z",
    fill: "url(#paint2_linear_1633_7154)",
    stroke: "url(#paint3_linear_1633_7154)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1633_7154",
    x1: 7.31982,
    y1: 12.0217,
    x2: 24.6651,
    y2: 12.0217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4776E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E54E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1633_7154",
    x1: 7.31982,
    y1: 12.0217,
    x2: 24.6651,
    y2: 12.0217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4776E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E54E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1633_7154",
    x1: 0.839355,
    y1: 25.4648,
    x2: 31.1606,
    y2: 25.4648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4776E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E54E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1633_7154",
    x1: 0.839355,
    y1: 25.4648,
    x2: 31.1606,
    y2: 25.4648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4776E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E54E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/iconUpload.db0696aa7547d39572f915038874992c.svg";
export { ForwardRef as ReactComponent };